import { useIntl } from '@leagueplatform/locales';
import { Link } from 'common/types';
import { createLink } from 'utils/navigation-links.utils';
import { useProductSegmentation } from './use-product-segmentation.hook';

export function useSupportLinks(): Link[] {
  const { formatMessage } = useIntl();
  const { showFormsCenter } = useProductSegmentation();

  const links: Link[] = [];

  if (showFormsCenter) {
    links.push(createLink('formsCenter', formatMessage));
  }

  links.push(createLink('customerSupport', formatMessage));

  return links;
}
